// The analytics pages follow the data when it has gone quiet: an export that
// ends Aug 18, viewed in late September, shows the 30 days up to Aug 18
// instead of "No data yet" (backend helpers.period_window). This line says so.

const WINDOW_LABEL: Record<string, string> = { week: '7 days', month: '30 days', quarter: '90 days' };

export function describeDataEnds(dataEnds: string | null | undefined, period: string): string {
  if (!dataEnds) return '';
  const day = new Date(`${dataEnds}T12:00:00Z`).toLocaleDateString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC',
  });
  return `Your latest sales are from ${day} — showing the ${WINDOW_LABEL[period] ?? '30 days'} up to then.`;
}

// The window a page's totals cover, the way a person would write it:
// "Aug 1 – Aug 31, 2026", or "Dec 15, 2026 – Jan 13, 2027" across New Year.
// Noon keeps a YYYY-MM-DD on its own day in every zone.
export const formatRange = (start: string, end: string): string => {
  const d = (s: string) => new Date(`${s}T12:00:00`);
  const md = (x: Date) => x.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  const [s, e] = [d(start), d(end)];
  const startYear = s.getFullYear() !== e.getFullYear() ? `, ${s.getFullYear()}` : '';
  return `${md(s)}${startYear} – ${md(e)}, ${e.getFullYear()}`;
};
